function AccountsLoginCtrl($scope, $state, $stateParams, $rootScope, $q, $window, $translate, toastr, UserService, AuthService, AppSettings) {
  'ngInject';

  var vm = this;

  $window.sessionStorage.clear();

  // if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
  //   vm.isDebugger = true;
  // }

  // 선택한 언어 적용
  if ($stateParams.lang) {
    $translate.use($stateParams.lang);
  }

  vm.userTypes = AppSettings.userTypes;

  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    vm.isLocalhost = true;
  }

  vm.isMobile = window.mobilecheck();
  if (location.protocol === 'file:') {
    vm.isMobileApp = true;
  }

  //vm.selectedObj = vm.userTypes[0];
  vm.selectedObj = null;

  vm.loginData = {
    login_id: null,
    passwd: null
  };

  vm.submit = function () {
    if (confirm('부정경쟁방지관련 동의를 하시겠습니까?')) {
      UserService.login(vm.loginData).then(function (res) {
        var data = res.data;
        if (data.result === 'NOT') {
          toastr.error('없는 사용자 아이디입니다.');
        } else if (data.result === 'NO_MATCH') {
          toastr.error('비밀번호가 맞지 않습니다.');
        } else if (data.result === 'NOT_YET') {
          toastr.error('팀 승인이 필요한 아이디입니다.');
        } else {
          if (vm.autoLogin == '1') {
            window.localStorage.setItem('login_id', vm.loginData.login_id);
            window.localStorage.setItem('passwd', vm.loginData.passwd);
          } else {
            window.localStorage.removeItem('login_id');
            window.localStorage.removeItem('passwd');
          }

          AuthService.setUser(data);
          var d = $q.defer();
          var dataInfo = {
            "user_id": data.user_id,
            "uuid": data.uuid
          };
          d.resolve(dataInfo);
          return d.promise;
        }
      }).then(function (dataInfo) {

        var lang = $stateParams.lang ? $stateParams.lang : '';

        UserService.info(dataInfo).then(function (res) {
          AuthService.setInfo(res.data);

          // 팀 설정이 되어 있지 않은 경우 - sa21c 관리자 제외 : SA21C parent_id(18), 본사관리자(22), 최고관리자(23), 후원팬(17), 일반팬(28) 제외
          if (res.data.team_id === '0' && res.data.user_type_id != '17' && res.data.user_type_id != '18' && res.data.user_type_id != '22' && res.data.user_type_id != '23' && res.data.user_type_id != '28') {
            toastr.error('팀을 선택하지 않으셨습니다. 수정을 클릭하시고 팀을 선택해주세요');
            $state.go('Service.member', { 'target': 'MyInfo', 'team_id': 0, 'lang': lang });
          }
          else if (res.data.user_type_id == '11' || res.data.user_type_id == '17' || res.data.user_type_id == '18' || res.data.user_type_id == '22' || res.data.user_type_id == '23' || res.data.user_type_id == '28') {
            // 후원팬, 일반팬
            if (res.data.user_type_id == '17' || res.data.user_type_id == '28') {
              $state.go('Service.member', { 'target': 'MyInfo', 'team_id': 0, 'lang': lang });
            }
            // 선수
            else if (res.data.user_type_id == '1' || vm.loginData.login_id === 'ceo@sa21c.com') {
                $state.go('Service.playerDetail', { user_id: dataInfo.user_id, team_id: res.data.team_id, 'lang': lang });
              } else if (vm.loginData.login_id === 'headcoach@kfa.or.kr') {
                $state.go('Service.player', { type_code: 'team', type_name: '팀', team_id: res.data.team_id, 'lang': lang });
              } else {
                // if (vm.loginData.login_id === 'ceo@sa21c.com') {
                // $state.go('Service.admin', { type_code:'team', 'v': 'sa21c', 'lang': lang });
                // } else {
                $state.go('Service.planner', { type_code: 'team', team_id: res.data.team_id, 'lang': lang });
                // }
              }
          }
          // 무료 회원 로그인 차단 - 아래 허용된 팀만 로그인 허용
          // 20210831 현재 유료 결제로 로그인이 허용된팀
          // 유료결제팀
          // 1. 경기평택시티즌유소년축구단 (초등)   team_id: 27504
          // 2. 서울노원R.FC (초등)               team_id: 27516
          // 3. 강원원주리더스 (초등)             team_id: 27478
          // 4. 청주프로비티FC (초등)             team_id: 27651
          // 5. 최강희축구교실 / FC아쏘 (초등)     team_id: 27654

          // 데이터바우처
          // 1. 경기용인레이번스U15 (중등)        team_id: 26607
          // 2. 경기안산아르마다FCU12 (초등)      team_id: 27619
          // 3. 경기양주탑클래스U12 (초등)        team_id: 27456

          // 국가대표팀                         team_id: 53
          // else if (
          //   res.data.team_id != '27504' &&
          //   res.data.team_id != '27516' &&
          //   res.data.team_id != '27478' &&
          //   res.data.team_id != '27651' &&
          //   res.data.team_id != '27654' &&
          //   res.data.team_id != '26607' &&
          //   res.data.team_id != '27619' &&
          //   res.data.team_id != '27456' &&
          //   res.data.team_id != '53'
          // ) {
          //   alert('현재 무료 유저입니다.\n유료 결제를 통해서 리뉴얼된 새로운 기능을 사용해보세요');
          //   return false;
          // }
          else {
            // 후원팬, 일반팬
            if (res.data.user_type_id == '17' || res.data.user_type_id == '28') {
              $state.go('Service.member', { 'target': 'MyInfo', 'team_id': 0, 'lang': lang });
            }
            // 선수
            else if (res.data.user_type_id == '1' || vm.loginData.login_id === 'ceo@sa21c.com') {
                $state.go('Service.playerDetail', { user_id: dataInfo.user_id, team_id: res.data.team_id, 'lang': lang });
              } else if (vm.loginData.login_id === 'headcoach@kfa.or.kr') {
                $state.go('Service.player', { type_code: 'team', type_name: '팀', team_id: res.data.team_id, 'lang': lang });
              } else {
                // if (vm.loginData.login_id === 'ceo@sa21c.com') {
                // $state.go('Service.admin', { type_code:'team', 'v': 'sa21c', 'lang': lang });
                // } else {
                $state.go('Service.planner', { type_code: 'team', team_id: res.data.team_id, 'lang': lang });
                // }
              }
          }
        });
      });
    } else {
      alert('동의 후 로그인하실 수 있습니다.');
      return false;
    }
  };

  // view 가 load 된 이후에 실행
  $scope.$on('$viewContentLoaded', function () {
    // 자동 로그인 시작
    if (window.localStorage.getItem('autoLogin') && window.localStorage.getItem('autoLogin') == '1') {
      vm.autoLogin = '1';
    } else {
      vm.autoLogin = '0';
    }

    if (vm.autoLogin == '1') {
      vm.loginData.login_id = window.localStorage.getItem('login_id');
      vm.loginData.passwd = window.localStorage.getItem('passwd');
    }

    $scope.$watch('accountsLogin.autoLogin', function (newVal, oldVal) {
      window.localStorage.setItem('autoLogin', newVal);
    });
    // 자동 로그인 끝
  });
}

export default {
  name: 'AccountsLoginCtrl',
  fn: AccountsLoginCtrl
};
